module.exports = __webpack_public_path__ + "assets/img/tab3_05.db3236d2.jpg";